/** Canonical public site URL (production). */
export const SITE_ORIGIN = 'https://www.restroai.in';

export function absoluteUrl(path = '/') {
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_ORIGIN}${p}`;
}
